module.exports = __webpack_public_path__ + "static/media/background-img.988bf0a1.jpg";